import { LogTimeUnit } from '../pages/Log/shared';
import {
  LogTypeEnum,
  QuarantineLogTypeEnum,
  TimeRangeInterface,
} from '../types/log';

const envSettings = window as typeof window & { [k: string]: string };
export default {
  ui: {
    deployEnv: 'local',
    siteName: 'dev_wu',
    cookieDomain: '.tmcas.trendmicro.net',
    authUrl: 'https://auth-stg.tmcas.trendmicro.com/?T=',
    isDefaultUI: true,
    reCaptcha: {
      sitekey: '6LcuEF0pAAAAABCcx-3MZw8k21yax23HpIgOljyg',
    },
    contextMenuEnabled: true,
    clpLogoutUrl: `https://${envSettings.DEPLOY_AUTH_ADDR}/module.php/core/authenticate.php?as=tmss365-sp-${envSettings.DEPLOY_AUTH_ENV}&logout`,
    siteInfo: {
      v1: {
        prod_wu: 'https://portal.xdr.trendmicro.com',
        prod_we: 'https://portal.eu.xdr.trendmicro.com',
        prod_je: 'https://portal.jp.xdr.trendmicro.com',
        prod_ac: 'https://portal.au.xdr.trendmicro.com',
        prod_sa: 'https://portal.sg.xdr.trendmicro.com',
        prod_ci: 'https://portal.in.xdr.trendmicro.com',
        prod_nuae: 'https://portal.mea.xdr.trendmicro.com',
        stg_wu: 'https://portal-xdr.visionone.trendmicro.com',
        beta_wu: 'https://portal-int.visionone.trendmicro.com',
        dev_wu: 'https://portal-xdr.visionone.trendmicro.com',
        prod_uae_stg: 'https://portal-stg-uae.visionone.trendmicro.com',
      },
    },
    deployRegion: envSettings.DEPLOY_REGION,
    loginPage: {
      startFreeTrail: envSettings.CLP_REGISTRATION_TRIAL,
      contactReseller:
        'https://partner.trendmicro.com/en-US/partner-locator-home/',
      forgotPassword: envSettings.CLP_FORGOT_PASSWORD + '/Forgetpassword?T=TM',
    },
    classicUrl:
      envSettings.CAS_CLASSIC_UI_DOMAIN ||
      'https://admin-classic-dev.tmcas.trendmicro.net',
    prefix: import.meta.env.VITE_PUBLIC_URL === '/' ? '' : '/ui/cas',
    uicPrefix: '/app/email-and-collaboration',
    request: {
      baseUrl: '',
      timeout: 60 * 1000,
    },
    noAuthLogOff: true,
    timeZone: {
      defaultOffsetId: '32',
      defaultOffset: '+00:00',
    },
    upgradeDeadline: {
      globalPhase1: '2026-02-28',
    },
    '3rdParties': {
      i18nextDebug: false,
    },
    widgetCategoryShowConfig: {
      scam: true,
      atp_srs: true,
      atp_va: true,
      dp: true,
      risky: true,
      ransomware: true,
      summary: true,
      bec: true,
      quishing: true,
      total_detections: true,
    },
    // if this switch is decided by config and DB tm_global_setting for company,so it is for company'
    //!!important: if you want to add new feature toggle, please also add it to featureToggleForCompanyConfig
    featureToggle: {
      urlSandboxFeatureShow: true,
      ddaTempQuarantineFeatureShow: true,
      smexQuarantineManagementEnabled: false,
      whiteLabelingFeatureToggle: false,
      writingStyleFeatureShow: false,
      gmailQtSettingFeatureShow: false,
      mipFeatureShow: false,
      mipAndTokenFeatureShow: false,
      activeContentSanitizingExceptionListFeatureShow: false,
      exOutboundTocFeatureShow: false,
      rmsFeatureShow: false,
      gmailInlineFeatureShow: true,
      exchangeInlineFeatureShow: true,
      notificationMailboxesFeatureShow: true,
      smexHybridFeatureShow: true,
      logRestoreAllFeatureShow: false,
      googleDriveRealtimeScanSupport: false,
      aggressiveNameSpoofing: false,
      gmailAddInConfigEnabled: false,
      passwordQuarantineFeatureShow: true,
    },
    feature: {
      whiteLabeling: {
        enabled: true,
        path: envSettings.DEPLOY_WHITE_LABEL_PATH,
        fullName: 'Cyber Eye Cloud Service Security',
        firstName: 'Cyber Eye',
        lastName: 'Cloud Service Security',
      },
      phishInsight:
        'https://stg.phishinsight.trendmicro.com/api/auth/sso/clp/?sso',
    },
    //!!important this switch is a temp switch,when develop done,all will be open
    hideFeature: {
      redirectV1Banner: false,
      sideBar: {
        dashboard: false,
        log: false,
        policy: false,
        report: false,
        quarantine: false,
        administrator: false,
        visionOne: false,
      },
      dashboard: {
        widgetCategory: false,
        exportPDFReport: false,
        exportVirtualAnalyzerABlockList: false,
      },
      header: {
        accountSwitch: false,
        accountSetting: {
          logOff: false,
        },
        colorSwitch: false,
      },
      quarantine: {
        exQtSetting: true,
      },
    },
    pendoApiKey: 'c6143613-39c2-4a58-6f8f-50da2ef57a1a',
    reportDefaultValue: {
      reportContent: {
        total: true,
        bec: true,
        phishing: true,
        ransomware: true,
        maliciousFile: true,
        maliciousURL: true,
        spam: true,
        anomaly: true,
        spoofing: true,
        dlp: true,
      },
      formatContent: {
        coverDescription: '',
        companyName: '',
        isCompanyLogoDisplay: true,
        fileInfo: {
          fileError: '',
        },
        isTrendLogoDisplay: true,
        isDefaultSettingSave: false,
      },
    },
    logDefaultValue: {
      debounceInterval: 3000,
      logState: {
        page: {
          start: 1,
          size: 100,
        },
        sort: {
          field: 'timestamp',
          direction: 'desc',
        },
        type: 'detection' as LogTypeEnum,
        timeRange: {} as TimeRangeInterface,
        logs: [],
        criteria: [],
        facets: [],
        allFacets: {},
        isLoading: false,
        isFacetLoading: false,
        total: 0,
        columnConfig: {
          order: [],
          hideIds: [],
        },
        virusLinks: {},
        l10nMap: {},
        chartData: [],
        isChartLoading: false,
        loadChart: '',
      },
      logContentParams: {
        type: 'detection' as const,
        page: {
          start: 1,
          size: 100,
        },
        sort: {
          field: 'timestamp',
          direction: 'desc',
        },
        timeRange: {
          predefined: 'all' as LogTimeUnit,
          start: '',
          end: '',
        },
        searches: '',
      },
      hideSearchFields: [
        'fileStatus',
        'quarantineType',
        'filterType',
        'action',
        'ddaaasRiskLevel',
        'scanSource',
        'securityFilterName',
        'scanType',
        'urlCategory',
        'errorCode',
        'ddaaasScanType',
        'wrsRiskLevel',
        'spamCategory',
        'appTypeValue',
        'eventCategoryValue',
        'eventTypeValue',
        'fileTypeCategoryValue',
        'malwareDetectedBy',
        'restoreBy',
        'riskPreventionType',
        'policySeverity',
        'actionSource',
        //'messageId',
        //'productServerName',
        'mailDirection',
        'deliveredStatus',
        'protectionMode',
        'mergedSecurityRiskName',
        'companyGuid',
        'serviceGenre',
        'riskLevel',
        'sanctionStatus',
        'dataSource',
        'blockReason',
      ],
    },
    quarantineDefaultValue: {
      quarantineLogState: {
        quarantineType: QuarantineLogTypeEnum.Exchange,
        logs: [],
        allFacets: {},
        criteria: [],
        facets: [],
        timeRange: {} as TimeRangeInterface,
        total: 0,
        page: { start: 1, size: 100 },
        sort: {
          field: 'timestamp',
          direction: 'desc',
        },
        trigger: null,
        // columnConfig: {
        //   order: [],
        //   hideIds: [],
        // },
      },
    },
    policy: {
      policyTemplateTypes: {
        emailTypes: [1, 82, 21, 22],
        collaborationTypes: [2, 3, 4, 5, 6, 9, 10, 41, 42],
      },
      //!!important this switch is a temp switch,when develop done,all will be open
      featureShow: {
        emailAdvancedThreatProtection: true,
        emailDataLossPrevention: true,
        collaborationAdvancedThreatProtection: true,
        collaborationDataLossPrevention: true,
        activeContentSanitizingExceptionListFeatureShow: true,
        ddaTempQuarantineFeatureShow: true,
        aggressiveNameSpoofing: false,
      },
      limitation: {
        approvedListMaxCount: 1024,
        vsDisarmExceptListMaxCount: 2048,
        blockedListMaxCount: 1024,
        blockedUrlMaxCount: 1024,
        singleApprovedListMaxCount: 256,
        singleBlockedListMaxCount: 256,
        policyNameMaxLength: 128,
        policyDescMaxLength: 1024,
        replacementFileNameMaxLength: 52,
        unScannableReplacementFileNameMaxLength: 52,
        fileExtensionMaxLength: 255,
        fileNameMaxLength: 255,
        fileTypeSearchMaxLength: 255,
        notifyToMaxLength: 255,
        notifySubjectMaxLength: 200,
        notifyMessageMaxLength: 4095,
        notifyToAccountMaxLength: 255,
        fileReplacement: 1023,
        policyPriorityMaxLength: 5,
        policyPriorityMaxNumber: 99999,
        disclaimerMaxLength: 1024,
        approvedHeaderMaxLength: 128,
        approvedHeaderMaxNumber: 50,
        blockedHeaderMaxLength: 128,
        blockedHeaderMaxNumber: 10,
        blockFileExtensionCount: 1000,
        approvedFileExtensionCount: 1000,
        boxFileExtensionCount: 1000,
        fileExtensionErrorMessageCount: 50,
        fileNameTagMaxLength: 20,
        inlineGroupUserMaxLength: Number(
          envSettings.INLINE_MAX_USER_NUMBER_IN_O365_GROUP
        ),
        tocApprovedListMaxCount: 1024,
        singleTocApprovedListMaxCount: 256,
        fbFileMaxSize: '150MB',
      },
      fileTypes: [
        {
          title: 'policy.treeData.fileType.title',
          key: 'policy.treeData.fileType,key',
          folder: true,
          expanded: true,
          children: [
            {
              key: 'policy.treeData.fileType.appExec.key',
              title: 'policy.treeData.fileType.appExec.title',
              folder: true,
              children: [
                {
                  key: 'ELF',
                  title: 'policy.treeData.fileType.appExec.ELF.title',
                },
                {
                  key: 'EXE',
                  title: 'policy.treeData.fileType.appExec.EXE.title',
                },
                {
                  key: 'JAVA',
                  title: 'policy.treeData.fileType.appExec.JAVA.title',
                },
                {
                  key: 'WIN_LNK',
                  title: 'policy.treeData.fileType.appExec.WIN_LNK.title',
                },
                {
                  key: 'MSI',
                  title: 'policy.treeData.fileType.appExec.MSI.title',
                },
                {
                  key: 'DMG',
                  title: 'policy.treeData.fileType.appExec.DMG.title',
                },
              ],
            },
            {
              key: 'policy.treeData.fileType.doc.key',
              title: 'policy.treeData.fileType.doc.title',
              folder: true,
              children: [
                {
                  key: 'PDF',
                  title: 'policy.treeData.fileType.doc.PDF.title',
                },
                {
                  key: 'CHM',
                  title: 'policy.treeData.fileType.doc.CHM.title',
                },
                {
                  key: 'MSO',
                  title: 'policy.treeData.fileType.doc.MSO.title',
                },
                {
                  key: 'MDB',
                  title: 'policy.treeData.fileType.doc.MDB.title',
                },
                {
                  key: 'EXCEL',
                  title: 'policy.treeData.fileType.doc.EXCEL.title',
                },
                {
                  key: 'XLSX',
                  title: 'policy.treeData.fileType.doc.XLSX.title',
                },
                {
                  key: 'PPTX',
                  title: 'policy.treeData.fileType.doc.PPTX.title',
                },
                {
                  key: 'DOCX',
                  title: 'policy.treeData.fileType.doc.DOCX.title',
                },
                {
                  key: 'VSDX',
                  title: 'policy.treeData.fileType.doc.VSDX.title',
                },
                {
                  key: 'WINWORD',
                  title: 'policy.treeData.fileType.doc.WINWORD.title',
                },
                {
                  key: 'PPT',
                  title: 'policy.treeData.fileType.doc.PPT.title',
                },
                {
                  key: 'PROJECT',
                  title: 'policy.treeData.fileType.doc.PROJECT.title',
                },
                {
                  key: 'RTF',
                  title: 'policy.treeData.fileType.doc.RTF.title',
                },
                {
                  key: 'DWORD',
                  title: 'policy.treeData.fileType.doc.DWORD.title',
                },
                {
                  key: 'HLP',
                  title: 'policy.treeData.fileType.doc.HLP.title',
                },
                {
                  key: 'MSFT',
                  title: 'policy.treeData.fileType.doc.MSFT.title',
                },
                {
                  key: 'WP',
                  title: 'policy.treeData.fileType.doc.WP.title',
                },
                {
                  key: 'ONE',
                  title: 'policy.treeData.fileType.doc.ONE.title',
                },
              ],
            },
            {
              key: 'policy.treeData.fileType.image.key',
              title: 'policy.treeData.fileType.image.title',
              folder: true,
              children: [
                {
                  key: 'GIF',
                  title: 'policy.treeData.fileType.image.GIF.title',
                },
                {
                  key: 'CPT',
                  title: 'policy.treeData.fileType.image.CPT.title',
                },
                {
                  key: 'GFT',
                  title: 'policy.treeData.fileType.image.GFT.title',
                },
                {
                  key: 'JPEG',
                  title: 'policy.treeData.fileType.image.JPEG.title',
                },
                {
                  key: 'MAC',
                  title: 'policy.treeData.fileType.image.MAC.title',
                },
                {
                  key: 'PNG',
                  title: 'policy.treeData.fileType.image.PNG.title',
                },
                {
                  key: 'TIFF',
                  title: 'policy.treeData.fileType.image.TIFF.title',
                },
                {
                  key: 'BMP',
                  title: 'policy.treeData.fileType.image.BMP.title',
                },
                {
                  key: 'WMF',
                  title: 'policy.treeData.fileType.image.WMF.title',
                },
              ],
            },
            {
              key: 'policy.treeData.fileType.video.key',
              title: 'policy.treeData.fileType.video.title',
              folder: true,
              children: [
                {
                  key: 'ASF',
                  title: 'policy.treeData.fileType.video.ASF.title',
                },
                {
                  key: 'SWF',
                  title: 'policy.treeData.fileType.video.SWF.title',
                },
                {
                  key: 'MPG',
                  title: 'policy.treeData.fileType.video.MPG.title',
                },
                {
                  key: 'AVI',
                  title: 'policy.treeData.fileType.video.AVI.title',
                },
                {
                  key: 'QTM',
                  title: 'policy.treeData.fileType.video.QTM.title',
                },
                {
                  key: 'RMF',
                  title: 'policy.treeData.fileType.video.RMF.title',
                },
                {
                  key: 'FLV',
                  title: 'policy.treeData.fileType.video.FLV.title',
                },
              ],
            },
            {
              key: 'policy.treeData.fileType.sound.key',
              title: 'policy.treeData.fileType.sound.title',
              folder: true,
              children: [
                {
                  key: 'MIDI',
                  title: 'policy.treeData.fileType.sound.MIDI.title',
                },
                {
                  key: 'MP3',
                  title: 'policy.treeData.fileType.sound.MP3.title',
                },
                {
                  key: 'RA',
                  title: 'policy.treeData.fileType.sound.RA.title',
                },
                {
                  key: 'WAV',
                  title: 'policy.treeData.fileType.sound.WAV.title',
                },
              ],
            },
            {
              key: 'policy.treeData.fileType.compressedFile.key',
              title: 'policy.treeData.fileType.compressedFile.title',
              folder: true,
              children: [
                {
                  key: 'LHA',
                  title: 'policy.treeData.fileType.compressedFile.LHA.title',
                },
                {
                  key: 'PKZIP',
                  title: 'policy.treeData.fileType.compressedFile.PKZIP.title',
                },
                {
                  key: 'RAR',
                  title: 'policy.treeData.fileType.compressedFile.RAR.title',
                },
                {
                  key: 'TAR',
                  title: 'policy.treeData.fileType.compressedFile.TAR.title',
                },
                {
                  key: 'ARJ',
                  title: 'policy.treeData.fileType.compressedFile.ARJ.title',
                },
                {
                  key: 'BINHEX',
                  title: 'policy.treeData.fileType.compressedFile.BINHEX.title',
                },
                {
                  key: 'GZIP',
                  title: 'policy.treeData.fileType.compressedFile.GZIP.title',
                },
                {
                  key: 'LZW',
                  title: 'policy.treeData.fileType.compressedFile.LZW.title',
                },
                {
                  key: 'MACBIN',
                  title: 'policy.treeData.fileType.compressedFile.MACBIN.title',
                },
                {
                  key: 'MSCF',
                  title: 'policy.treeData.fileType.compressedFile.MSCF.title',
                },
                {
                  key: 'MSCOMP',
                  title: 'policy.treeData.fileType.compressedFile.MSCOMP.title',
                },
                {
                  key: 'MIME',
                  title: 'policy.treeData.fileType.compressedFile.MIME.title',
                },
                {
                  key: 'TD0',
                  title: 'policy.treeData.fileType.compressedFile.TD0.title',
                },
                {
                  key: 'BZIP2',
                  title: 'policy.treeData.fileType.compressedFile.BZIP2.title',
                },
                {
                  key: 'UUCODE',
                  title: 'policy.treeData.fileType.compressedFile.UUCODE.title',
                },
                {
                  key: 'ACE',
                  title: 'policy.treeData.fileType.compressedFile.ACE.title',
                },
                {
                  key: '7Z',
                  title: 'policy.treeData.fileType.compressedFile.7Z.title',
                },
              ],
            },
          ],
        },
      ],
      manualScanTrailUserAllow: {
        email: 25,
        others: 5,
      },
      validTokenList: [
        '%scanaction%',
        '%filtername%',
        '%product_name%',
        '%security_risk_name%',
        '%action%',
        '%date%',
        '%time%',
        '%foundin%',
        '%violator%',
        '%filename%',
        '%suspicious_url%',
        '%risk_level%',
        '%url_category%',
        '%dlptemplatename%',
        '%policy_name%',
      ],
    },
    administrator: {
      featureShow: {
        organization: true,
        serviceAccount: true,
        userRole: true,
        license: true,
        SingleSignOn: true,
        apiToken: true,
        euq: true,
      },
      addInInstallLink: envSettings.ADD_IN_INSTALL_LINK,
      smartAlertAddInInstallLink: `https://${envSettings.DEPLOY_SA_ADDIN_FQDN}/manifest.xml`,
      apiTokenUrl: envSettings.API_TOKEN_URL,
    },
    globalSettings: {
      limitation: {
        approvedHeaderMaxLength: 128,
        approvedHeaderMaxNumber: 50,
        approvedUserMaxLength: 1024,
        blockedListMaxCount: 2048,
        predictiveMachineLearningMaxCount: 500,
        displayNameSpoofingDetectionExceptionListMaxCount: 500,
        recipientGroupInputMaxLength: 254,
        recipientGroupTextAreaMaxLength: 1024,
        recipientGroupMaxNumber: 21,
        highProfileUserExceptionListMaxCount: 500,
        highProfileDomainsMaxCount: 1000,
        highProfileUserMaxCount: 1000,
        internalDomainList: 1024,
        orgNameMaxLength: 32,
        orgTextAreaMaxLength: 1024,
        exchangePocUserLimit: 100,
      },
      //!!important this switch is a temp switch,when develop done,all will be open
      featureShow: {
        attachmentPasswordGuessing: true,
        conditionalAccessPoliciesForRiskyUsers: true,
        misdirectedEmailDetection: true,
        microsoftLicensingModelSettingsForTeamsChat: true,
        inlineProtectionSettingsForExchangeOnline: true,
        inlineProtectionSettingsForGmail: true,
        highProfileList: true,
        internalDomainList: true,
        timeOfClickProtection: true,
        machineLearning: true,
      },
    },
  },
  bff: {
    apiPreFix: '/bff',
  },
};
